var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperbag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6673 16.666C26.6673 18.4341 25.9649 20.1298 24.7147 21.3801C23.4645 22.6303 21.7688 23.3327 20.0007 23.3327C18.2325 23.3327 16.5368 22.6303 15.2866 21.3801C14.0364 20.1298 13.334 18.4341 13.334 16.666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17188 10.0566H34.8285",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 9.11232C5.23393 9.6893 5 10.3911 5 11.1123V33.334C5 34.218 5.35119 35.0659 5.97631 35.691C6.60143 36.3161 7.44928 36.6673 8.33333 36.6673H31.6667C32.5507 36.6673 33.3986 36.3161 34.0237 35.691C34.6488 35.0659 35 34.218 35 33.334V11.1123C35 10.3911 34.7661 9.6893 34.3333 9.11232L31 4.66732C30.6895 4.25333 30.2869 3.91732 29.824 3.68589C29.3612 3.45447 28.8508 3.33398 28.3333 3.33398H11.6667C11.1492 3.33398 10.6388 3.45447 10.176 3.68589C9.7131 3.91732 9.31049 4.25333 9 4.66732L5.66667 9.11232Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperbag);
export default __webpack_public_path__ + "static/media/paperbag.d143d922b359b69bf39ab18dda8f3903.svg";
export { ForwardRef as ReactComponent };